import type { Accommodation } from '../types';
import { imageUrl } from './images';

export const ACCOMMODATIONS: Accommodation[] = [
  {
    id: 'camp-lucy',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'dripping-springs-fitzhugh',
    name: 'Camp Lucy',
    description:
      'The strongest luxury base on the route: resort lodging, vineyard context, polished dining, and the on-site olive-oil class that makes it both stay and tasting stop.',
    address: '3509 Creek Rd',
    city: 'Dripping Springs',
    state: 'TX',
    lat: 30.2236,
    lng: -98.0538,
    image: imageUrl('olive-orchard-field'),
    hours: 'Resort lodging year-round; activities book separately.',
    website: 'https://www.camplucy.com/',
    phone: '(512) 894-4400',
    highlights: ['Luxury resort', 'On-site olive-oil tasting', 'Spa', 'Wine-country setting'],
    priceRange: '$$$$',
    style: 'Resort',
    petFriendly: false,
    amenities: ['Spa', 'On-site dining', 'Daily activities', 'Vineyard setting'],
  },
  {
    id: 'lucky-arrow-retreat',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'dripping-springs-fitzhugh',
    name: 'Lucky Arrow Retreat',
    description:
      'A design-forward Dripping Springs base with cabins, glamping energy, and enough amenities to work for travelers who want Hill Country atmosphere without full-resort pricing.',
    address: '3600 Bell Springs Rd',
    city: 'Dripping Springs',
    state: 'TX',
    lat: 30.1885,
    lng: -98.1247,
    image: imageUrl('olive-hills'),
    hours: 'Year-round lodging.',
    website: 'https://www.luckyarrowretreat.com/about',
    phone: '(512) 400-4402',
    highlights: ['Boutique retreat', 'Pet-friendly', 'Pools + beer garden', 'Near Bell Springs'],
    priceRange: '$$$',
    style: 'Retreat',
    petFriendly: true,
    amenities: ['Heated pools', 'Restaurant', 'Walking trails', 'Pet-friendly rooms'],
  },
  {
    id: 'alexander-at-creek-road',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'dripping-springs-fitzhugh',
    name: 'The Alexander at Creek Road',
    description:
      'A country-style boutique lodging property close to Camp Lucy and Dripping Springs, positioned well for a quieter Hill Country stay.',
    address: '6730 Creek Rd',
    city: 'Dripping Springs',
    state: 'TX',
    lat: 30.213,
    lng: -98.045,
    image: imageUrl('single-olive-branch'),
    hours: 'Year-round lodging.',
    website: 'https://www.thealexanderatcreekroad.com/',
    highlights: ['40 scenic acres', 'Multiple lodging formats', 'Close to Creek Road venues', 'Dark-sky feel'],
    priceRange: '$$$',
    style: 'Guesthouse',
    petFriendly: false,
    amenities: ['Treehouse suites', 'Cottages', 'Group reservations', 'Quiet grounds'],
  },
  {
    id: 'gruene-river-hotel',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'new-braunfels-gruene',
    name: 'Gruene River Hotel & Retreat',
    description:
      'The cleanest stay pairing for the Gruene tasting-room stop: river frontage, walking access to the historic district, and an adults-oriented boutique feel.',
    address: '1235 Gruene Rd',
    city: 'New Braunfels',
    state: 'TX',
    lat: 29.7399,
    lng: -98.1574,
    image: imageUrl('olive-tasting-plate'),
    hours: 'Year-round lodging.',
    website: 'https://www.grueneriverhotel.com/',
    phone: '(830) 643-1234',
    highlights: ['Guadalupe River frontage', 'Walk to Gruene Hall', 'Breakfast + evening wine', 'Adults-oriented'],
    priceRange: '$$$',
    style: 'River Hotel',
    petFriendly: false,
    amenities: ['River views', 'Breakfast included', 'Evening wine', 'Private balconies'],
  },
  {
    id: 'sophies-gasthaus',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'new-braunfels-gruene',
    name: "Sophie's Gasthaus",
    description:
      'A restored 1906 boutique property in downtown New Braunfels that works well for travelers who want a more design-forward urban base before or after Gruene.',
    address: '487 W San Antonio St',
    city: 'New Braunfels',
    state: 'TX',
    lat: 29.7011,
    lng: -98.1262,
    image: imageUrl('olive-oil-shelf'),
    hours: 'Year-round lodging.',
    website: 'https://www.sophiesgasthaus.com/',
    highlights: ['Historic property', 'Downtown setting', 'Pool courtyard', 'Eight unique suites'],
    priceRange: '$$$',
    style: 'Boutique Hotel',
    petFriendly: false,
    amenities: ['Outdoor pool', 'Art-filled interiors', 'Downtown access', 'Suite-style rooms'],
  },
  {
    id: 'la-fonda-on-the-plaza',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'santa-fe-plaza',
    name: 'La Fonda on the Plaza',
    description:
      'A classic Santa Fe base directly on the Plaza, ideal for the walkable tasting-room chapter and one of the cleanest stay pairings for the downtown olive stop.',
    address: '100 E San Francisco St',
    city: 'Santa Fe',
    state: 'NM',
    lat: 35.6872,
    lng: -105.9378,
    image: imageUrl('olive-tasting-plate'),
    hours: 'Year-round lodging.',
    website: 'https://lafondasantafe.com/contact/',
    phone: '(505) 982-5511',
    highlights: ['On the Plaza', 'Historic hotel', 'Santa Fe landmark', 'Walkable tasting base'],
    priceRange: '$$$$',
    style: 'Boutique Hotel',
    petFriendly: false,
    amenities: ['Historic character', 'Central Plaza location', 'Restaurants on site', 'Art-filled interiors'],
  },
  {
    id: 'la-posada-de-santa-fe',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'santa-fe-plaza',
    name: 'La Posada de Santa Fe',
    description:
      'A full-service casita-style resort steps from the Plaza that gives the New Mexico chapter a higher-end stay option with spa and resort infrastructure.',
    address: '330 E Palace Ave',
    city: 'Santa Fe',
    state: 'NM',
    lat: 35.6854,
    lng: -105.9338,
    image: imageUrl('olive-bottle-counter'),
    hours: 'Year-round lodging.',
    website: 'https://www.marriott.com/SAFLC',
    highlights: ['Downtown resort', 'Casita-style rooms', 'Spa', 'Walkable to Plaza'],
    priceRange: '$$$$',
    style: 'Resort',
    petFriendly: false,
    amenities: ['Spa', 'Outdoor pool', 'On-site dining', 'Downtown location'],
  },
  {
    id: 'the-scott-resort',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'queen-creek-phoenix',
    name: 'The Scott Resort & Spa',
    description:
      'A polished Scottsdale base that works well for the Arizona chapter when travelers want a stronger hotel experience and are willing to day-trip to Queen Creek.',
    address: '4925 N Scottsdale Rd',
    city: 'Scottsdale',
    state: 'AZ',
    lat: 33.5105,
    lng: -111.9257,
    image: imageUrl('olive-hills'),
    hours: 'Year-round lodging.',
    website: 'https://www.thescottresort.com/',
    phone: '(480) 945-7666',
    highlights: ['Scottsdale resort', 'Spa', 'Downtown access', 'Strong desert design'],
    priceRange: '$$$$',
    style: 'Resort',
    petFriendly: false,
    amenities: ['Spa', 'Pools', 'Restaurant', 'Scottsdale location'],
  },
  {
    id: 'hotel-adeline',
    type: 'accommodation',
    verified: true,
    lastVerified: '2026-04-22',
    region: 'queen-creek-phoenix',
    name: 'Hotel Adeline',
    description:
      'A livelier Scottsdale boutique option for the Arizona leg, better suited to travelers who want nightlife and a younger hotel energy around their tasting route.',
    address: '5101 N Scottsdale Rd',
    city: 'Scottsdale',
    state: 'AZ',
    lat: 33.5123,
    lng: -111.9258,
    image: imageUrl('olive-branch-close'),
    hours: 'Year-round lodging.',
    website: 'https://www.hoteladeline.com/',
    highlights: ['Boutique Scottsdale hotel', 'Pool scene', 'Restaurant + bar', 'Central metro base'],
    priceRange: '$$$',
    style: 'Boutique Hotel',
    petFriendly: false,
    amenities: ['Pool', 'Restaurant', 'Bar', 'Scottsdale access'],
  },
];
